module.exports = __webpack_public_path__ + "images/home/product/mobile/features-todolist-2836bfd6209dfff1c5bd7267dc6a48a8.png";